import React, { useEffect, useState } from 'react';
const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPosition = window.scrollY;
      if (totalHeight) {
        setProgress(scrollPosition / totalHeight * 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-0 left-0 right-0 h-1 bg-gray-200 z-50" data-id="element-285">
      <div className="h-full bg-green-600 transition-all duration-300" style={{
      width: `${progress}%`
    }} data-id="element-286"></div>
    </div>;
};
export default ReadingProgressBar;